// @ts-nocheck
import styled, { css } from 'styled-components';
import { scarpaGray400, scarpaGray800, turquoise800, spanishViridian500, robotoRegular } from '@habitech/shared';

import { GridContainer } from 'src/components/common/grids';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const Title = styled.div`
    font-size: 24px;
    font-weight: bold;
    color: ${scarpaGray800};
    margin-top: 24px;
    margin-bottom: 24px;
`;

export const SearchWrapper = styled(GridContainer)`
    padding: 8px 0;
    align-items: center;
`;

export const TextBasic = css`
    font-size: 16px;
    margin: 16px 0;
`;

export const Text = styled.div`
    ${TextBasic}
    color: ${scarpaGray400};
`;

export const BoldText = styled.div`
    ${TextBasic};
    font-weight: bold;
`;

export const Pmodal = styled.p`
    margin: 80px 0px;
    text-align:center;
    font-family: ${robotoRegular};
`;

export const MigrateFeedDiv = styled.div`
    display: inline-flex;
    align-items: center;
    h3 {
        margin-left: 8px;
        margin-right:13px;
      }
`;

export const CustomDatePicker = styled(DatePicker)`
    border-radius: 10px;
    border: 2px solid ${turquoise800};
    padding: 5px;
    font-size: 15px;
    height: 36px;
    text-align: center;
    width:95%

    `;
export const DatepickerContainer = styled.div`

  `;

export const DownButton = styled.div`
    width: 30px;
    height: 30px;
    display: block;
    margin: auto;
    svg path {
        fill: ${spanishViridian500};
    }
`;
